import React from 'react'
import { Form, Input } from 'antd-mobile-v5'
import { FormattedMessage, injectIntl } from 'react-intl'
import CardLayout from './CardLayout'
import { formatDate } from './utils'
import UserPhoto from './UserPhoto'

import styles from '../../pages/DiveMasterForm/DiveMasterForm.module.css'
//update: delete
const DiverInfo = ({ diver }) => {
  const { englishName, birthDate } = diver
  const status = Boolean(englishName && birthDate)

  return (
    <CardLayout title={<FormattedMessage id="dm-form-diver-info" />} status={status}>
      <div className={styles['diver-info']}>
        <div style={{ flex: 1 }}>
          <Form layout="horizontal">
            <Form.Item label={<FormattedMessage id="dm-form-name" />}>
              <Input type="text" value={englishName} readOnly />
            </Form.Item>
            <Form.Item label={<FormattedMessage id="dm-form-birth" />}>
              <Input type="text" value={formatDate(birthDate, 'YYYY-MM-DD')} readOnly />
            </Form.Item>
          </Form>
        </div>
        <UserPhoto />
      </div>
    </CardLayout>
  )
}

export default injectIntl(DiverInfo)
